export var getPartLocale = function (fullLocale) {
    return fullLocale.replace(/^(\w{2})(.*)/, '$1');
};
